/**
 * La paleta de reacciones.
 *
 * Tiene que coincidir con `comentarios_mg/emojis.py`: el servidor valida contra
 * su copia y rechaza cualquier otra cosa. Es una lista fija a proposito — un
 * selector de emojis de verdad son ~1,900 caracteres, agrupados, con buscador y
 * con fuente de respaldo, o sea una libreria entera para algo que en la practica
 * se usa con media docena.
 */
export const EMOJIS = ['👍', '❤️', '😂', '🎉', '👀', '✅', '🔥', '🙏']

export default (client) => {
  return {
    lista(tableId, rowId) {
      return client.get(`/comentarios-mg/tabla/${tableId}/fila/${rowId}/`)
    },
    crear(tableId, rowId, mensaje, menciones = []) {
      return client.post(`/comentarios-mg/tabla/${tableId}/fila/${rowId}/`, {
        mensaje,
        menciones,
      })
    },
    borrar(comentarioId) {
      return client.delete(`/comentarios-mg/${comentarioId}/`)
    },
    avisos(tableId, rowId) {
      return client.get(`/comentarios-mg/tabla/${tableId}/fila/${rowId}/avisos/`)
    },
    fijarAvisos(tableId, rowId, modo) {
      return client.put(
        `/comentarios-mg/tabla/${tableId}/fila/${rowId}/avisos/`,
        { modo }
      )
    },
    miembros(tableId) {
      return client.get(`/comentarios-mg/tabla/${tableId}/miembros/`)
    },
    reaccionar(comentarioId, emoji) {
      return client.post(`/comentarios-mg/${comentarioId}/reaccion/`, { emoji })
    },
    quitarReaccion(comentarioId, emoji) {
      // El cuerpo de un DELETE va en `data` con axios; pasarlo como segundo
      // argumento —como en post— lo manda como config y el emoji no llega.
      return client.delete(`/comentarios-mg/${comentarioId}/reaccion/`, {
        data: { emoji },
      })
    },
  }
}
